import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

/**
 * "Property Profile" link on a seller lead (DOMA 13321183498).
 *
 * The national profile at the lead's address (every Australian address, VIC
 * matched for now), sent as `property_profile` ({ id, url }). Public data, so
 * anyone who can see the lead can open it. A real link, so it can be opened in
 * a new tab, and it never also opens the row it sits in.
 */
const PropertyProfileLink = ({ profile, className = '' }) => {
  if (!profile?.id) return null;
  return (
    <Link
      to={profile.url || `/collings-data-properties/property/${profile.id}`}
      onClick={(e) => e.stopPropagation()}
      title="Open the Property Profile at this address"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-100 hover:bg-emerald-100 whitespace-nowrap ${className}`}
    >
      <MapPin className="w-3 h-3" />
      Property Profile
    </Link>
  );
};

export default PropertyProfileLink;
